<template>
  <Chart id="appregion" class="container" v-bind="regionChart" />
</template>

<script>
import { Chart } from "@international-energy-agency/vue-ui/highcharts";

export default {
  name: "RegionChart",
  components: {
    Chart,
  },
  data() {
    return {
      regionChart: {
        title:
          "Global public energy RD&D budget with share of low-carbon, 2015-2022",
        units: "billion USD (2022)",
        chartType: "column",
        series: [
          {
            name: "North America",
            data: [
              [2015, 8.338],
              [2016, 8.326],
              [2017, 8.442],
              [2018, 9.762],
              [2019, 10.353],
              [2020, 11.048],
              [2021, 11.138],
              [2022, 10.665],
            ],
          },
          {
            name: "Japan Korea Australia New Zealand",
            data: [
              [2015, 3.135],
              [2016, 2.851],
              [2017, 2.778],
              [2018, 3.205],
              [2019, 3.208],
              [2020, 3.201],
              [2021, 3.357],
              [2022, 3.477],
            ],
          },
          {
            name: "Europe",
            data: [
              [2015, 8.304122],
              [2016, 8.091244],
              [2017, 8.722471],
              [2018, 8.680339],
              [2019, 9.599603],
              [2020, 10.182919],
              [2021, 11.733084],
              [2022, 11.711084],
            ],
          },
          {
            name: "China",
            data: [
              [2015, 7.89965375259011],
              [2016, 7.88602789102863],
              [2017, 9.05538881805278],
              [2018, 10.1093491297166],
              [2019, 9.19442340837082],
              [2020, 10.1680014083209],
              [2021, 12.1516759597636],
              [2022, 14.8987021799826],
            ],
          },
          {
            name: "Rest of World",
            data: [
              [2015, 3.39073808992974],
              [2016, 3.08971974189294],
              [2017, 2.83233432428523],
              [2018, 3.00910580964739],
              [2019, 3.05722934398193],
              [2020, 3.36488217927751],
              [2021, 3.0695222053482],
              [2022, 2.88412787808987],
            ],
          },
          {
            name: "Global share of low-carbon",
            type: "line",
            yAxis: 1,
            colorIndex: 7,
            data: [
              [2015, 71.89],
              [2016, 71.6],
              [2017, 73.33],
              [2018, 73.77],
              [2019, 78.02],
              [2020, 79.15],
              [2021, 80.13],
              [2022, 81.31],
            ],
            tooltip: {
              valueSuffix: "%",
              valueDecimals: 1,
            },
          },
        ],
        chartOptions: {
          xAxis: {
            type: "category",
          },
          yAxis: [
            {
              title: {
                enabled: false,
              },
            },
            {
              labels: {
                format: "{value}%",
              },
              title: {
                enabled: false,
              },
              opposite: true,
              min: 0,
            },
          ],
        },
      },
    };
  },
};
</script>
